import type { Dispatch, SetStateAction } from 'react';

import { toastManager } from '@crm/entities/toast';
import { resolveApiError } from '@crm/shared/api';
import { mapApiFieldErrors } from '@crm/shared/lib';

import type { FieldErrors } from './informationBlockFields';
import type { TUpdateDealDetailsFieldName } from '@crm/entities/deal';

export const informationBlockFieldByPointer = {
    customerName: 'customer_name',
    phone: 'phone',
    email: 'email',
    source: 'source',
    receivedAt: 'received_at',
    objectType: 'object_type',
    area: 'area',
    approximateBudget: 'approximate_budget',
    requestEssence: 'request_essence',
} as const satisfies Readonly<Record<string, TUpdateDealDetailsFieldName>>;

type HandleInformationBlockErrorParams = {
    error: unknown;
    fallback: string;
    setFieldErrors: Dispatch<SetStateAction<FieldErrors>>;
};

export const handleInformationBlockError = ({
    error,
    fallback,
    setFieldErrors,
}: HandleInformationBlockErrorParams) => {
    const resolvedError = resolveApiError(error, fallback);

    if (resolvedError.type === 'toast') {
        toastManager.onError({ title: resolvedError.message });
        return;
    }

    const mappedErrors = mapApiFieldErrors(
        resolvedError.errors,
        informationBlockFieldByPointer
    );

    if (!mappedErrors) {
        toastManager.onError({ title: resolvedError.summary });
        return;
    }

    const nextFieldErrors = Object.fromEntries(
        mappedErrors.map(({ field, message }) => [field, message])
    ) as FieldErrors;

    setFieldErrors((currentErrors) => ({ ...currentErrors, ...nextFieldErrors }));
};
